export const createConvention = ({ userId, fundId }) => {
    const payload = { userId: `${userId}` };

    if (fundId) payload.investmentFundId = `${fundId}`;

    return payload;
};
